export const state = () => ({
  isIosApp: false
})
export const mutations = {
  set(state, payload) {
    state.isIosApp = payload.isIosApp
  }
}
